import {
    AbstractControl,
    ValidationErrors,
    Validators,
} from '@angular/forms';

import isArray from 'lodash-es/isArray';

import { IValidatorOptions } from './validator.options';

export function maxLength(max: number, options?: IValidatorOptions) {
    const validator = Validators.maxLength(max);
    return (c: AbstractControl) => {
        const isNested = options && !!options.property;
        const entries = isArray(c.value) ? c.value : [c.value];

        let result: ValidationErrors | null = null;
        entries.forEach(entry => {
            const value = isNested && entry != null ?
                entry[options!.property!] :
                entry;

            result = validator({
                value,
            } as AbstractControl);
        });

        return result != null && isNested ? {
            [`${options!.property}.maxlength`]: result!.maxlength,
        } :
            result;
    };
}
